import * as React from 'react';
import { observer } from 'mobx-react';

import { injectTSDI } from '@core/tsdi';
import { TextField } from '@components/textfield';
import { Label } from '@components/label';
import { ChallengeAggregationType, ChallengeType } from '@api/ChallengeClient';
import { ChallengeRulesStore } from './store';
import { PersonalRulesStore } from './personal-rules/store';
import { challengeTargetUnit } from '../../rule-types';

interface ChallengeTargetProps {
    disabled?: boolean;
}

export const ChallengeTarget = observer(
    ({ disabled }: ChallengeTargetProps) => {
        const {
            fields: { ruleType, fitnessMetricType, aggregationType },
            validateRules
        } = injectTSDI(ChallengeRulesStore);
        const {
            fields: { strategy, pointsGoal },
            form
        } = injectTSDI(PersonalRulesStore);

        if (strategy.value !== ChallengeType.RACE) {
            return (
                <Label>
                    {aggregationType.value === ChallengeAggregationType.MIN
                        ? 'Members are ranked against each other; the lowest result wins.'
                        : 'Members are ranked against each other; the highest result wins.'}
                </Label>
            );
        }

        return (
            <>
                <TextField
                    type="number"
                    label="Target"
                    value={pointsGoal.value || ''}
                    onChange={(value) => {
                        pointsGoal.onChange(Number(value));
                        validateRules();
                        form.validate();
                    }}
                    error={pointsGoal.error}
                    InputLabelShrink
                    data-testid={`points-goal-challenge-goal-field`}
                    disabled={disabled}
                />
                <Label>
                    Measured in{' '}
                    {challengeTargetUnit(
                        ruleType.value,
                        fitnessMetricType.value
                    )}
                </Label>
            </>
        );
    }
);
